import { useMemo } from 'react';
import type { VisitStepFieldsConfig } from './use-ui-metadata-field-config.hook';

export const useIncludeHostStep = (config: VisitStepFieldsConfig): boolean =>
  useMemo(
    () =>
      config.alternativeHostsEnabled ||
      config.hostInvitationCopyEnabled ||
      config.hostCheckinNotificationEnabled ||
      !config.additionalRecipients.hidden ||
      !config.floor.hidden,
    [config],
  );
